import React, { useMemo } from "react"
import useBrowserMode from "../../../shared/hooks/useBrowserMode"
import { useScrollValue } from "../../../shared/hooks/useScrollValue"
import useMediaQuery from "../../../shared/utils/useMediaQuery"
import "./progressbar-article.scss"

const ProgressBarArticle = () => {
  const isMobile = useMediaQuery()
  const { scrollValue } = useScrollValue()
  const { isBrowser } = useBrowserMode()
  
  const percentWidht = useMemo(() => {
    if (isMobile) return 0
    
    const scrollHeight = isBrowser && document.documentElement.scrollHeight || 0

    return Math.round((scrollValue / (scrollHeight - 1000)) * 100)
  }, [scrollValue])
  
  const progressClassName = scrollValue > 10 
    ? "f-progressbar-article--active"
    : ""
  
  if (isMobile) return null
  return (
    <div className={`f-progressbar-article ${progressClassName}`} style={{ width: percentWidht + "%" }} />
  )
}

export default ProgressBarArticle
